module.exports = __webpack_public_path__ + "img/coupon-left.994073ab.png";